import { MenuDivider, Position } from "@blueprintjs/core"
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import ActionMenu from "components/Organisms/ActionMenu"
import ActionMenuItem from "components/Organisms/ActionMenuItem"
import { useAuthorizationModules } from "hooks/useAuth"
import { OPEN_BULK_UPDATE_DIALOG } from "store/order.redux"
import { NumberBadge } from "../../scheduling-new/header/SchedulingActions"
import ConsolidateOrdersDialog from "../consolidate/ConsolidateOrdersDialog"
import SummaryOrderItemDrawer from "../drawer/SummaryOrderItemDrawer"
const OrderBulkActions = ({ isCountFilter, count }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const path = location.pathname
  const selectedOrders = useSelector(state => {
    const selected = state.selector?.orders?.selected
    return selected ? Object.keys(selected) : []
  })
  const dispatch = useDispatch()
  const [isOpen, setOpen] = useState(false)
  const [isSummaryOpen, setSummaryOpen] = useState(false)

  const disabled = useAuthorizationModules("add", "order")
  function handleClick(type) {
    switch (type) {
      case "edit":
        dispatch({
          type: OPEN_BULK_UPDATE_DIALOG,
        })
        return
      case "shopping-cart":
        navigate("/d/ecom/orders/sellable-items")
        return
      case "th-list":
        navigate("/d/ecom/orders")
        return
      case "merge-links":
        const orders = btoa(selectedOrders.join(","))
        navigate(
          `/d/ecom/orders/add/new-consolidated?ords=${orders}&total=${
            count || 0
          }`
        )
        return
      case "import":
        navigate(`/d/import/orders`)
        return
      case "pie-chart":
        setSummaryOpen(true)
        return
      default:
        return
    }
  }

  return (
    <>
      <ActionMenu
        onClick={handleClick}
        popoverProps={{
          position: Position.BOTTOM_RIGHT,
        }}
      >
        <MenuDivider title="Add" />
        <ActionMenuItem
          disabled={disabled}
          icon="import"
          text="Bulk import orders"
        />
        <MenuDivider title="Update" />

        <ActionMenuItem
          icon="edit"
          text="Bulk Update"
          disabled={selectedOrders ? false : true}
          labelElement={
            isCountFilter ? (
              <NumberBadge count={count} intent="primary" />
            ) : (
              <NumberBadge selectedArray={selectedOrders} intent="primary" />
            )
          }
        />
        {path.includes("sellable-items") ? null : (
          <ActionMenuItem
            disabled={selectedOrders ? false : true}
            icon="merge-links"
            text="Consolidate Orders"
            labelElement={
              isCountFilter ? (
                <NumberBadge count={count} intent="primary" />
              ) : (
                <NumberBadge selectedArray={selectedOrders} intent="primary" />
              )
            }
          />
        )}
        <MenuDivider title="View" />
        {path.includes("sellable-items") ? (
          <ActionMenuItem icon="th-list" text="All Orders" />
        ) : (
          <ActionMenuItem icon="shopping-cart" text="Order By Sellable Item" />
        )}
        <ActionMenuItem icon="pie-chart" text="Summary" />
      </ActionMenu>
      <ConsolidateOrdersDialog
        icon="merge-links"
        isOpen={isOpen}
        onClose={e => setOpen(false)}
        light
      />
      <SummaryOrderItemDrawer isOpen={isSummaryOpen} setOpen={setSummaryOpen} />
    </>
  )
}

export default OrderBulkActions
